import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectBoxLayout from 'components/atoms/Modal/SelectBox.Layout';
import { isACtiveOrganization } from 'modules/actions/statusMenu/index';
import { organizationReset } from 'modules/actions/organization';
import ReactHtmlParser from 'react-html-parser';
import { chatList } from 'modules/actions/chat';
import { twoDeptList, twoDeptReset } from 'modules/actions/twoDept';
import { weBrowser } from 'lib';

const OrganizBox = () => {
  const dispatch = useDispatch();
  const [Selected, setSelected] = useState('');
  const [deptTWo, setDept] = useState('');

  const deptList = useSelector(state => state.organization.organizList);
  const deptTitle = useSelector(state => state.organization.organizTitle);

  const twoDept = useSelector(state => state.twoDept.twoDeptIndex);

  useEffect(() => {
    dispatch(twoDeptList(Selected));
  }, [Selected]);

  const handleSelect = e => {
    setSelected(e.target.value);
  };

  const handleTwoSelect = e => {
    setDept(e.target.value);
  };

  const onSendMessage = inStr => {
    let paramSet = {};
    if (deptTitle === '본청') {
      console.log('본청')
      paramSet = {
        inType: 'query',
        inStr: deptTitle + ' 부서 ' + inStr,
      };
    } else {
      console.log('그 외')
      paramSet = {
        inType: 'query',
        inStr: deptTitle + ' 부서 ' + inStr,
      };
    }

    dispatch(chatList(paramSet));
    dispatch(isACtiveOrganization());
  };
  const constentSet = () => {
    return (
      <>
        <div className="select_box_div">
          <select onChange={handleSelect} value={Selected}>
            {deptList !== undefined &&
              deptList.map((dept, idx) => {
                console.log(dept);
                return (
                  <option value={dept} key={dept + '_' + idx}>
                    {ReactHtmlParser(dept || '')}
                  </option>
                );
              })}
          </select>
          {/* 
             본청
          */}
          {deptTitle === '본청' && (
            <select onChange={handleTwoSelect} value={deptTWo}>
              {twoDept !== undefined &&
                twoDept.map((arryItem, idx) => {
                  return (
                    <option value={arryItem} key={arryItem + '_' + idx}>
                      {ReactHtmlParser(arryItem || '')}
                    </option>
                  );
                })}
            </select>
          )}
        </div>
        <div className="search_box_div">
          <div className="select_box_search two" onClick={() => onSendMessage(deptTitle === '본청' ? deptTWo : Selected)}>
            검색하기
          </div>
        </div>
      </>
    );
  };

  return (
    <SelectBoxLayout
      styleDef={{ height: weBrowser() ==='ie'? '161px':'auto' }}
      label={deptTitle}
      value={deptTitle}
      labelIcon='ri-sun-cloudy-line"'
      viewStatus=""
      error={null}
      onClickEvt={() => dispatch(isACtiveOrganization())}
      contentSet={constentSet}
    />
  );
};

export default OrganizBox;
